import { useEffect, useState } from "react";
import { fetchDayStatus } from "../api/attendance";
import { isNative } from "../native/capacitor";
import { scheduleShiftReminders } from "../native/localReminders";
import { registerPush } from "../native/pushRegister";

const isOff = (d) => Boolean(d && d.day_type !== "workday" && !d.work_allowed);
const localDate = (tzOff, addDays = 0) =>
  new Date(Date.now() + (tzOff || 0) * 60000 + addDays * 86400000).toISOString().slice(0, 10);

// يعيد برمجة التذكيرات كلما تغيّر الفرع أو حالة اليوم، ولا يُبرمج تذكيراً لليوم (أو الغد)
// إن كان عطلة — نجلب حالة الغد من الخادم لأن تذكير الحضور قد يُجدوَل للغد.
export const useMobileReminders = (branch, today, day) => {
  const checkedIn = Boolean(today?.check_in_at);
  const checkedOut = Boolean(today?.check_out_at);
  const offToday = isOff(day);
  const [offTomorrow, setOffTomorrow] = useState(false);

  useEffect(() => {
    if (!isNative() || !branch?.id) return;
    fetchDayStatus(branch.id, localDate(branch.tz_offset_minutes, 1))
      .then((d) => setOffTomorrow(isOff(d)))
      .catch(() => setOffTomorrow(false));
  }, [branch?.id, branch?.tz_offset_minutes]);

  useEffect(() => {
    if (!isNative() || !branch?.work_start) return;
    scheduleShiftReminders(branch, { checkedIn, checkedOut, offToday, offTomorrow }).catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [branch?.id, branch?.work_start, branch?.work_end, checkedIn, checkedOut, offToday, offTomorrow]);

  useEffect(() => {
    if (isNative()) registerPush().catch(() => {});
  }, []);
};
